import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Image "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Titre "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Sous titre "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Catégorie "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Alias "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Statut "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, " ACTIONS ")
  ])
], -1)
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_21 = { class: "dropdown-menu" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_27 = { key: 2 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-flash lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-flash lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 4 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_41 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddNewTagModal = _resolveComponent("AddNewTagModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkPermission('AddArticle'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                to: "/ajouter-article"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" Ajouter un article ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un article"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_6
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("img", {
                      src: _ctx.getUrlApiForFiles(article.urlImage),
                      alt: "Image",
                      width: "100",
                      height: "100"
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(article.titre.length > 20
                    ? article.titre.slice(0, 20) + " ..."
                    : article.titre), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(article.sousTitre.length > 20
                    ? article.sousTitre.slice(0, 20) + " ..."
                    : article.sousTitre), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(article?.categorieArticle?.nom.length > 20
                    ? article.categorieArticle?.nom.slice(0, 20) + " ..."
                    : article.categorieArticle?.nom), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(article.alias.length > 20
                    ? article.alias.slice(0, 20) + " ..."
                    : article.alias), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(article.estPublie ? "Publié" : "Dépublié"), 1),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("ul", _hoisted_21, [
                        (_ctx.checkPermission('EditArticle'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                              _createVNode(_component_router_link, {
                                to: {
                          name: 'EditArticlePage',
                          params: { id: article.id },
                        },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_23,
                                  _createTextVNode("Modifier")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('AddArticleTag'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddNewTagModal",
                                onClick: ($event: any) => (_ctx.openAddNewTagModal(article))
                              }, [
                                _hoisted_26,
                                _createTextVNode(" Ajouter de (s) tag (s) ")
                              ], 8, _hoisted_25)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('SwitchArticle'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                onClick: ($event: any) => (_ctx.switchArticle(article.id))
                              }, [
                                _hoisted_29,
                                (!article.estPublie)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, " Publié l'article"))
                                  : _createCommentVNode("", true),
                                (article.estPublie)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, " Dépublier l'article"))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_28)
                            ]))
                          : _createCommentVNode("", true),
                        (article.categorieArticle?.id == 3 )
                          ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                onClick: ($event: any) => (_ctx.alaUne(article.id))
                              }, [
                                _hoisted_34,
                                (!article.alaUne)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "En vedette"))
                                  : _createCommentVNode("", true),
                                (article.alaUne)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Masquer"))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_33)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('ViewArticle'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                              _createVNode(_component_router_link, {
                                to: {
                          name: 'ViewArticlePage',
                          params: { id: article.id },
                        },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_38,
                                  _createTextVNode("Détails ")
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (
                          _ctx.suppression(
                            article.id,
                            _ctx.articles,
                            'articles',
                            `l\'article ${article.id}`
                          )
                        )
                          }, [
                            _hoisted_40,
                            _createTextVNode(" Supprimer ")
                          ], 8, _hoisted_39)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddNewTagModal, {
      selectedArticle: _ctx.selectedArticle,
      selectedArticleId: _ctx.selectedArticleId
    }, null, 8, ["selectedArticle", "selectedArticleId"])
  ], 64))
}